import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';

class DigitalStorePlainPage extends React.Component {
	
	render() {
		return (
			<div>
				Plain page STUB
			</div>
		)
	}
}

export default DigitalStorePlainPage;
